import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILead } from 'next-common';

interface LeadState {
  lead: ILead;
}

const initialState: LeadState = {
  lead: null,
};

const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    setLead: (state, action: PayloadAction<ILead>) => {
      state.lead = action.payload;
    },
  },
});

export const { setLead } = leadSlice.actions;
export default leadSlice.reducer;
